<template>
  <div class="policy-announcement-detail" v-loading="loading">
    <div class="main">
      <div class="header">
        <div class="left">
          <div class="line-1"></div>
          <div class="line-2"></div>
          <span class="title">政策公告详情</span>
        </div>
        <div class="right">
          <el-button
            class="back-btn"
            icon="el-icon-back"
            @click="goBack"
            >返回</el-button>
        </div>
      </div>

      <div class="detail-content">
        <div class="content-card">
        <!-- 标题 -->
        <div class="detail-title">
          {{ detailData.title  }}
        </div>

        <!-- 创建时间 -->
        <div class="detail">
          <span 
              class="tag" 
              v-for="(tag, tagIndex) in (detailData.categoryLabel ? detailData.categoryLabel.split(',') : [])" 
              :key="tagIndex"
            >
              #{{ tag }}
            </span>
          <i class="el-icon-time"></i>
          <span>创建时间：{{ detailData.createTime  }}</span>
        </div>
        <!-- 正文内容 -->
        <div class="detail-body">
          <div class="body-content">
            {{ detailData.content || '暂无内容' }}
          </div>
        </div>
        <div class="media-section" v-if="photoList.length > 0 || videoList.length > 0">
          <div class="photo-list" v-if="photoList.length > 0">
            <div 
              class="photo-item" 
              v-for="(photo, index) in photoList" 
              :key="index"
              @click="previewImage(photo)"
            >
              <img :src="photo" alt="照片" />
            </div>
          </div>
          <div class="video-list" v-if="videoList.length > 0">
            <div 
              class="video-item" 
              v-for="(video, index) in videoList" 
              :key="index"
            >
              <video :src="video" controls></video>
            </div>
          </div>
        </div>
        <div class="file-section" v-if="fileList.length > 0">
          <div 
            class="file-item" 
            v-for="(file, index) in fileList" 
            :key="index"
            @click="downloadFile(file.url)"
          >
            <i class="el-icon-document"></i>
            <span>{{ file.name }}</span>
            <i class="el-icon-download"></i>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { policyAnnouncementDetail } from '@/api/announcement/index';
export default {
  name: 'PolicyAnnouncementDetail',
  data() {
    return {
      loading: false,
      detailData: {
        title: '',
        content: '',
        createTime: '',
        photo: '',
        video: '',
        file: '',
        fileName: ''
      }
    }
  },
  computed: {
    photoList() {
      if (!this.detailData.photo) return [];
      return this.detailData.photo.split(',').filter(url => url.trim());
    },    // 视频列表
    videoList() {
      if (!this.detailData.video) return [];
      return this.detailData.video.split(',').filter(url => url.trim());
    },
    fileList() {
      if (!this.detailData.file) return [];
      const fileUrls = this.detailData.file.split(/[,\s]+/).filter(url => url.trim());
      const fileNames = this.detailData.fileName ? this.detailData.fileName.split(',').map(n => n.trim()).filter(n => n) : [];
      
      return fileUrls.map((url, index) => ({
        url: url.trim(),
        name: fileNames[index] || url.split('/').pop() || '未知文件'
      }));
    }
  },
  created() {
    // 获取路由参数中的 id
    const id = this.$route.query.id;
    if (id) {
      this.getDetail(id);
    }
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },

    // 获取详情数据
    async getDetail(id) {
        this.loading = true;
        const res = await policyAnnouncementDetail(id);
          if(res.data && res.data.code === 200) {
          this.detailData = res.data.data;
          console.log(this.detailData);
          this.loading = false;
        } else {
          this.$message.error(res.data.message);
          this.loading = false;
        }
    },
    // 预览图片
    previewImage(url) {
      // 在新窗口打开图片
      window.open(url, '_blank');
    },
    // 下载文件
    downloadFile(url) {
      if (!url || url === 'null') {
        this.$message.error('文件地址不存在');
        return;
      }
      window.open(url);
    },
    // 获取文件名
    getFileName(url) {
      if (!url) return '未知文件';
      const urlParts = url.split('/');
      return urlParts[urlParts.length - 1] || '未知文件';
    }
  }
}
</script>

<style lang="scss" scoped>
.policy-announcement-detail {
  background-color: #f0f2f5;
  height: 100%;
  overflow: auto;
}

.main {
  background-color: #fff;
  
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    padding: 0 21px;
    
    .left {
      display: flex;
      align-items: center;
      
      .line-1 {
        width: 4px;
        height: 18px;
        background: #01aaa7;
        border-radius: 2px;
      }
      
      .line-2 {
        margin-left: 2px;
        width: 2px;
        height: 18px;
        background: #01aaa7;
        border-radius: 1px;
      }
      
      .title {
        margin-left: 9px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
    }
    
    .right {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      display: flex;
      flex-direction: row;
      
      .back-btn {
        background-color: #01aaa7;
        color: #fff;
      }
    }
  }
}

.detail-content {
  .content-card {
    background: #FFFFFF;
    padding: 30px;
    
    .detail-title {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      text-align: center;
      color: #333333;
      line-height: 1.5;
      margin-bottom: 20px;
      word-break: break-word;
    }
    
    .detail{
      text-align: center;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #999999;
      padding-bottom: 20px;
      border-bottom: 1px solid #E5E5E5;
      .tag {
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #50C4CB;
          background-color: #F0F9FA;
          padding: 4px 8px;
          margin-right: 8px;
          border-radius: 4px;
        }
      i {
        margin-right: 8px;
        font-size: 16px;
      }
    }
    
    .detail-body {
      margin-bottom: 30px;
      .body-content {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        white-space: pre-wrap;
        word-break: break-word;
        line-height: 1.8;
      }
    }

    // 照片和视频区域（居中）
    .media-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 30px;
      padding-top: 30px;
      border-top: 1px solid #E5E5E5;

      .photo-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 15px;
        width: 100%;
        margin-bottom: 20px;

        .photo-item {
          cursor: pointer;
          border-radius: 4px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s;

          &:hover {
            transform: scale(1.05);
          }

          img {
            max-width: 400px;
            max-height: 400px;
            width: auto;
            height: auto;
            display: block;
          }
        }
      }

      .video-list {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        width: 100%;

        .video-item {
          width: 100%;
          max-width: 800px;

          video {
            width: 100%;
            max-height: 500px;
            border-radius: 4px;
            background: #000;
          }
        }
      }
    }

    // 文件链接区域（底部左侧）
    .file-section {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding-top: 30px;
      border-top: 1px solid #E5E5E5;

      .file-item {
        display: flex;
        align-items: center;
        padding: 10px 15px;
        margin-bottom: 10px;
        background-color: #F5F7FA;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s;
        min-width: 200px;

        &:hover {
          background-color: #E4E7ED;
          color: #50C4CB;
        }

        .el-icon-document {
          font-size: 18px;
          margin-right: 10px;
          color: #50C4CB;
        }

        span {
          flex: 1;
          font-size: 14px;
          font-family: Source Han Sans CN;
          color: #333333;
          word-break: break-all;
        }

        .el-icon-download {
          margin-left: 10px;
          color: #50C4CB;
        }
      }
    }
  }
}
</style>

